module.exports = __webpack_public_path__ + "img/arrow-lg.442845a5.svg";